import React, { useEffect, useState } from "react";

const TARGET = new Date("2026-12-01T00:00:00").getTime();

const pad = (n) => String(n).padStart(2, "0");

const compute = () => {
  let diff = Math.max(0, TARGET - Date.now());
  const d = Math.floor(diff / 86400000); diff -= d * 86400000;
  const h = Math.floor(diff / 3600000); diff -= h * 3600000;
  const m = Math.floor(diff / 60000); diff -= m * 60000;
  const s = Math.floor(diff / 1000);
  return { d, h, m, s };
};

const Countdown = () => {
  const [t, setT] = useState(compute);
  useEffect(() => {
    const id = setInterval(() => setT(compute()), 1000);
    return () => clearInterval(id);
  }, []);

  return (
    <div className="card" data-testid="countdown-card">
      <p
        style={{
          textAlign: "center",
          fontSize: 13,
          letterSpacing: 1.5,
          textTransform: "uppercase",
          color: "var(--muted)",
          fontWeight: 700,
          marginBottom: 14,
        }}
      >
        Soft launch in
      </p>
      <div className="count">
        <div className="u"><div className="n" data-testid="countdown-days">{t.d}</div><div className="l">Days</div></div>
        <div className="u"><div className="n" data-testid="countdown-hours">{pad(t.h)}</div><div className="l">Hours</div></div>
        <div className="u"><div className="n" data-testid="countdown-mins">{pad(t.m)}</div><div className="l">Mins</div></div>
        <div className="u"><div className="n" data-testid="countdown-secs">{pad(t.s)}</div><div className="l">Secs</div></div>
      </div>
      <div className="promo-tag">
        Early members get <b>WELCOME15</b> — 15% off the first booking
      </div>
    </div>
  );
};

export default Countdown;
